module.exports = __webpack_public_path__ + "static/media/pattern-bg.30de278c.jpg";